/* HRD garage runtime + selector overlay. Requires HRDFitmentCore loaded first. */
(function () {
  'use strict';
  var KEY = 'hrd_garage';
  /* Where "shop parts for your car" goes. Every surface that offers to shop a
     saved car points here: the hero, the garage overlay, and the PDP no-fit
     recovery. It used to be /collections/street-performance-dampers hardcoded
     in eight places, which sent a Civic owner to coilovers and hid the mounts,
     knobs and springs that actually fit. The view renders the whole catalogue
     through the standard fitment collection layout, so the saved car filters
     it. Liquid surfaces may still override per instance via
     data-fitment-shop-url; this is the default and the JS fallback. */
  var SHOP_FITS_URL = '/collections/all?view=fits';
  var core = window.HRDFitmentCore;
  var indexUrl = window.HRD_FITMENT_URL;
  if (!core || !indexUrl) return;

  var index = null;
  var storageBroken = false;
  var memYmm = null; // used only when storage is broken

  function readYmm() {
    if (storageBroken) return memYmm;
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return raw && typeof raw.ymm === 'string' ? raw.ymm : null;
    } catch (e) { return memYmm; }
  }
  function writeYmm(ymm) {
    memYmm = ymm;
    try {
      if (ymm == null) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, JSON.stringify({ ymm: ymm }));
      storageBroken = false;
    } catch (e) { storageBroken = true; }
  }

  function getGarage() {
    if (!index) return null;
    var ymm = readYmm();
    if (!ymm) return null;
    var g = core.resolveYmm(index, ymm);
    if (!g) { writeYmm(null); return null; } // clear gracefully per spec
    return g;
  }

  function announce(message) {
    var live = document.querySelector('[data-fitment-live]');
    if (live) live.textContent = message || '';
  }

  function broadcast() {
    browseAll = false;
    var g = getGarage();
    renderChips(g);
    document.dispatchEvent(new CustomEvent('hrd:vehicle:change', { detail: { garage: g } }));
    announce(g ? 'Showing parts for ' + g.label + '.' : 'Showing all parts.');
  }

  function setGarage(vehicleIdx, year) {
    var v = index.vehicles[vehicleIdx];
    writeYmm(year + '|' + v.make + '|' + v.model);
    broadcast();
  }
  function clearGarage() { writeYmm(null); broadcast(); }

  var chipsHydrated = false; // suppress the dot pulse on the first render pass (page load)

  function renderChips(g) {
    var v = g ? garageVehicle(g) : null;
    var labelTxt = g ? g.year + ' ' + v.model : 'Select your car';
    document.querySelectorAll('[data-fitment-chip]').forEach(function (el) {
      var label = el.querySelector('[data-fitment-chip-label]');
      var labelChanged = false;
      if (label && label.textContent !== labelTxt) { label.textContent = labelTxt; labelChanged = true; }
      el.classList.toggle('fitment-chip--set', !!g);
      el.setAttribute('aria-label', g ? 'Your car: ' + g.label + '. Change car.' : 'Select your car');
      var plus = el.querySelector('[data-fitment-chip-plus]');
      if (plus) plus.hidden = !!g;
      var sub = el.querySelector('[data-fitment-chip-sub]');
      if (sub) {
        var showSub = !!(g && v && v.chassis);
        sub.hidden = !showSub;
        if (showSub && sub.textContent !== '· ' + v.chassis) sub.textContent = '· ' + v.chassis;
      }
      var action = el.querySelector('[data-fitment-chip-action]');
      if (action) action.hidden = !g;
      var dot = el.querySelector('.fitment-chip__dot');
      if (dot && g && labelChanged && chipsHydrated) {
        dot.classList.remove('is-pulsing');
        void dot.offsetWidth;
        dot.classList.add('is-pulsing');
      }
    });
    chipsHydrated = true;
  }

  var activePill = null; // make-pill state, per page load, only meaningful with no garage
  var browseAll = false; // per-page view toggle; the garage survives it

  function hydrateBars() {
    var g = getGarage();
    document.querySelectorAll('[data-fitment-bar]').forEach(function (bar) {
      var none = bar.querySelector('[data-fitment-bar-none]');
      var active = bar.querySelector('[data-fitment-bar-active]');
      var browsing = bar.querySelector('[data-fitment-bar-browsing]');
      var label = bar.querySelector('[data-fitment-bar-label]');
      var labelB = bar.querySelector('[data-fitment-bar-label-browsing]');
      var cta = bar.querySelector('[data-fitment-bar-cta]');
      var toggle = bar.querySelector('[data-fitment-browse-toggle]');
      var pills = bar.querySelector('[data-fitment-pills]');
      if (none) none.hidden = !!g;
      if (active) active.hidden = !g || browseAll;
      if (browsing) browsing.hidden = !g || !browseAll;
      if (label && g && label.textContent !== g.label) label.textContent = g.label;
      if (labelB && g && labelB.textContent !== g.label) labelB.textContent = g.label;
      var ctaTxt = g ? 'Change car' : 'Select your car';
      if (cta && cta.textContent !== ctaTxt) cta.textContent = ctaTxt;
      if (toggle) {
        toggle.hidden = !g;
        var tTxt = browseAll ? 'Show my parts' : 'Show all';
        if (toggle.textContent !== tTxt) toggle.textContent = tTxt;
      }
      var barClear = bar.querySelector('[data-fitment-bar-clear]');
      if (barClear) barClear.hidden = !g;
      if (pills) pills.hidden = !!g; // pills structure the no-car view only
      var stateBox = bar.querySelector('[data-fitment-bar-state]');
      if (stateBox) {
        var stateKey = !g ? 'none' : (browseAll ? 'browsing' : 'active');
        var changed = bar.dataset.fitmentState !== stateKey;
        bar.dataset.fitmentState = stateKey;
        if (changed && bar.dataset.fitmentSwapReady === '1' && !reducedMotion()) {
          stateBox.classList.remove('fitment-swap-in');
          void stateBox.offsetWidth;
          stateBox.classList.add('fitment-swap-in');
        }
        bar.dataset.fitmentSwapReady = '1';
      }
    });
  }

  var pendingHide = [];
  var hideTimer = null;
  function flushPendingHides() {
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    pendingHide.forEach(function (c) { c.classList.add('fitment-hidden'); c.classList.remove('fitment-leaving', 'fitment-entering'); });
    pendingHide = [];
  }

  function hydrateGrids() {
    // Leak gate: only migrated templates filter; annotate-only grids (search)
    // hydrate notes without a bar and never hide a card.
    if (!document.querySelector('[data-fitment-bar]') && !document.querySelector('[data-fitment-annotate]')) return;
    flushPendingHides(); // a new pass settles any in-flight leave animations first
    var g = getGarage();
    var paginated = !!document.querySelector('.pagination'); // probed every pass (m12)
    var pageFitting = 0; // honest client count for the bar state line
    document.querySelectorAll('[data-fitment-grid]').forEach(function (grid) {
      // Annotate-only (search): the user asked for these results by name -
      // rows annotate fit against the saved car, hiding is forbidden.
      var annotateOnly = grid.hasAttribute('data-fitment-annotate');
      // First hydration per page load applies states instantly; only user-driven changes animate.
      var animate = grid.dataset.fitmentHydrated === '1' && !reducedMotion() && !document.hidden;
      var enterCount = 0;
      function setCardHidden(card, hide) {
        var wasHidden = card.classList.contains('fitment-hidden');
        if (hide === wasHidden) {
          if (!hide) card.classList.remove('fitment-leaving');
          return;
        }
        if (!animate) {
          card.classList.toggle('fitment-hidden', hide);
          card.classList.remove('fitment-leaving', 'fitment-entering');
          return;
        }
        if (hide) {
          card.classList.remove('fitment-entering');
          card.classList.add('fitment-leaving');
          pendingHide.push(card);
        } else {
          card.classList.remove('fitment-hidden', 'fitment-leaving');
          card.style.setProperty('--i', String(Math.min(enterCount++, 7)));
          card.classList.add('fitment-entering');
        }
      }
      var fitsCount = 0, universalCount = 0;
      // Scoped like applyGrouping: injected DOM (e.g. app modals) inside the grid must
      // never join the count; only real grid items carry .grid__item.
      grid.querySelectorAll('.grid__item[data-product-handle]').forEach(function (card) {
        var handle = card.getAttribute('data-product-handle');
        var note = card.querySelector('[data-fitment-note]');
        if (g) {
          var status = core.fitStatus(index, handle, g.vehicleIdx, g.year);
          setCardHidden(card, !annotateOnly && !browseAll && status === 'no-fit');
          if (status === 'fits') fitsCount++;
          if (status === 'universal') universalCount++;
          if (note) {
            // Tags only where they inform: in the filtered view every visible card fits
            // (the bar says so once), so fits-tags render only in the mixed browse-all grid.
            // Universal tags always differentiate, but drop the spec when the title already carries it.
            // Annotate grids are ALWAYS mixed, so every verifiable row gets its echo -
            // including an honest no-fit (legacy/no-data rows stay silent, never a false verdict).
            if (status === 'no-fit' && annotateOnly) {
              var ap = index.products[handle];
              var verifiable = ap && (ap.universal || (ap.fitments && ap.fitments.length));
              if (verifiable) {
                var nfTxt = "Doesn't fit your " + g.year + ' ' + garageVehicle(g).model;
                note.hidden = false;
                if (note.textContent !== nfTxt) note.textContent = nfTxt;
                note.className = 'grid-product__fit-note grid-product__fit-note--no-fit';
              } else { note.hidden = true; }
            }
            else if (status === 'fits' && (browseAll || annotateOnly)) {
              var fitsTxt = 'Fits your ' + g.year + ' ' + garageVehicle(g).model;
              note.hidden = false;
              if (note.textContent !== fitsTxt) note.textContent = fitsTxt;
              note.className = 'grid-product__fit-note grid-product__fit-note--fits';
            }
            else if (status === 'universal') {
              var spec = index.products[handle] && index.products[handle].spec;
              var uniTxt = 'Universal fit';
              if (spec) {
                var titleEl = card.querySelector('.grid-product__title');
                var titleTxt = titleEl ? titleEl.textContent.toLowerCase() : '';
                if (titleTxt.indexOf(String(spec).toLowerCase()) === -1) uniTxt = spec;
              }
              note.hidden = false;
              if (note.textContent !== uniTxt) note.textContent = uniTxt;
              note.className = 'grid-product__fit-note grid-product__fit-note--universal';
            }
            else { note.hidden = true; }
          }
        } else if (activePill) {
          var make = core.productMake(index, handle);
          var isUniversal = index.products[handle] && index.products[handle].universal;
          setCardHidden(card, !(make === activePill || isUniversal));
          if (note) { note.hidden = true; note.className = 'grid-product__fit-note'; }
        } else {
          setCardHidden(card, false);
          if (note) {
            note.hidden = true;
            if (note.textContent !== '') note.textContent = '';
            note.className = 'grid-product__fit-note';
          }
        }
      });
      var empty = grid.parentElement ? grid.parentElement.querySelector('[data-fitment-empty]') : null;
      if (empty) {
        empty.hidden = !(g && !browseAll && fitsCount === 0);
        var lbl = empty.querySelector('[data-fitment-empty-label]');
        if (lbl && g && lbl.textContent !== g.label) lbl.textContent = g.label;
        var uni = empty.querySelector('[data-fitment-empty-universal]');
        if (uni) uni.hidden = universalCount === 0;
      }
      /* Paginated grids never group: a bucket that spans pages is a lie about
         what page 2 holds. Show-all stays ungrouped too, since a no-fit card
         belongs to neither bucket and the mixed grid is the point. */
      var groupMode = null;
      if (!annotateOnly && !paginated) groupMode = !g ? 'make' : (browseAll ? null : 'fit');
      applyGrouping(grid, groupMode, g);
      grid.dataset.fitmentHydrated = '1';
      pageFitting += fitsCount + universalCount;
    });
    document.querySelectorAll('[data-fitment-bar-count]').forEach(function (el) {
      var txt = 'parts';
      if (g && !browseAll && pageFitting > 0) {
        txt = pageFitting === 1 ? '1 part' : pageFitting + ' parts';
      }
      if (el.textContent !== txt) el.textContent = txt;
    });
    if (pendingHide.length && !hideTimer) hideTimer = setTimeout(flushPendingHides, 160);
    updatePillCounts(g);
  }

  // Pills. Grouped (no-car, unpaginated) grids: pills are anchor chips that jump to
  // their make heading; counts live on the headings, dead anchors hide. Paginated
  // fallback keeps the legacy filter behavior without counts (page-scoped counts lie).
  function updatePillCounts(g) {
    var pills = document.querySelectorAll('[data-fitment-pill]');
    if (!pills.length) return;
    var paginated = !!document.querySelector('.pagination');
    var anchorMode = !g && !paginated;
    pills.forEach(function (pill) {
      var make = pill.getAttribute('data-fitment-pill');
      var key;
      if (anchorMode) {
        var target = findHeading(make);
        var live = !!(target && !target.hidden);
        if (pill.hidden !== !live) pill.hidden = !live;
        if (pill.hasAttribute('aria-pressed')) pill.removeAttribute('aria-pressed');
        key = make + '|anchor';
        if (pill.dataset.fitmentCountKey !== key) {
          pill.dataset.fitmentCountKey = key;
          pill.textContent = '';
          pill.appendChild(document.createTextNode(make));
          pill.removeAttribute('aria-label');
        }
      } else {
        if (pill.hidden) pill.hidden = false;
        if (!pill.hasAttribute('aria-pressed')) {
          pill.setAttribute('aria-pressed', make === activePill ? 'true' : 'false');
        }
        key = make + '|filter';
        if (pill.dataset.fitmentCountKey !== key) {
          pill.dataset.fitmentCountKey = key;
          pill.textContent = '';
          pill.appendChild(document.createTextNode(make));
          pill.removeAttribute('aria-label');
        }
      }
    });
  }

  /* ---------- make-group editorial headings (no-car, unpaginated grids only) ---------- */

  /* Two grouping modes.
     'make' is the no-car browse: headings are makes, universal last.
     'fit'  is the car-filtered view: the parts chosen for THIS car come first,
            then the ones that fit anything. Without it the two interleave in
            raw collection order and a spanner wrench sits between two mounts,
            which reads as though the wrench were picked for the car.
     Status is recomputed here rather than read off the card's classes: a card
     being hidden sits in .fitment-leaving for 160ms before .fitment-hidden
     lands, so class state at this moment is mid-animation and lies. */
  function cardGroup(handle, mode, g) {
    var p = index.products[handle];
    if (mode === 'fit') {
      var st = core.fitStatus(index, handle, g.vehicleIdx, g.year);
      if (st === 'fits') return 'Fits your ' + g.label;
      if (st === 'universal') return 'Universal fit';
      return null; // no-fit or unverifiable: no heading, sorts to the tail
    }
    // Catalog-group override outranks universal on purpose. It is the only way
    // to say "this has no per-car fitment, but it is still a Honda part": the
    // B/K mainshaft tool fits any Honda B/K box and no Subaru, so filing it
    // under 'Universal fit' next to the car soap is the less honest of the two.
    // Fit mode is untouched above, so an overridden product still reads
    // 'Universal fit' against a selected car and is never filtered out.
    if (p && p.group) return p.group;
    if (p && p.universal) return 'Universal fit';
    var make = core.productMake(index, handle);
    if (make) return make;
    return 'Other makes';
  }

  function groupOrder(groups, mode) {
    if (mode === 'fit') {
      var fits = Object.keys(groups).filter(function (l) { return l !== 'Universal fit'; });
      if (groups['Universal fit']) fits.push('Universal fit');
      return fits;
    }
    var known = ['Honda', 'Acura', 'Subaru', 'Toyota', 'Nissan', 'Mazda', 'Hyundai'];
    var labels = Object.keys(groups);
    var out = known.filter(function (k) { return labels.indexOf(k) !== -1; });
    labels.filter(function (l) { return known.indexOf(l) === -1 && l !== 'Universal fit' && l !== 'Other makes'; })
      .sort().forEach(function (l) { out.push(l); });
    if (groups['Universal fit']) out.push('Universal fit');
    if (groups['Other makes']) out.push('Other makes');
    return out;
  }

  function findHeading(label) {
    var els = document.querySelectorAll('[data-fitment-make-heading]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-fitment-make-heading') === label) return els[i];
    }
    return null;
  }

  function applyGrouping(grid, mode, g) {
    var heads = {};
    grid.querySelectorAll('[data-fitment-make-heading]').forEach(function (h) {
      heads[h.getAttribute('data-fitment-make-heading')] = h;
    });
    if (!mode) {
      Object.keys(heads).forEach(function (k) { if (!heads[k].hidden) heads[k].hidden = true; });
      return;
    }
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.grid__item[data-product-handle]'));
    if (!cards.length) {
      Object.keys(heads).forEach(function (k) { if (!heads[k].hidden) heads[k].hidden = true; });
      return;
    }
    var groups = {};
    var tail = []; // hidden or unverifiable cards: no heading, kept after the groups
    cards.forEach(function (card) {
      var k = cardGroup(card.getAttribute('data-product-handle'), mode, g);
      if (k === null) { tail.push(card); return; }
      (groups[k] = groups[k] || []).push(card);
    });
    var labels = groupOrder(groups, mode);
    // A lone group heading only repeats the masthead count; say nothing instead.
    if (labels.length === 1) {
      Object.keys(heads).forEach(function (k) { if (!heads[k].hidden) heads[k].hidden = true; });
      return;
    }
    var desired = [];
    labels.forEach(function (label) {
      var h = heads[label];
      if (!h) {
        h = document.createElement('h2');
        h.className = 'fitment-make-heading';
        h.setAttribute('data-fitment-make-heading', label);
        var name = document.createElement('span');
        name.className = 'fitment-make-heading__name';
        name.textContent = label;
        h.appendChild(name);
        var cnt = document.createElement('span');
        cnt.className = 'fitment-make-heading__count hrd-micro';
        h.appendChild(cnt);
        heads[label] = h;
      }
      if (h.hidden) h.hidden = false;
      var cntEl = h.querySelector('.fitment-make-heading__count');
      var n = groups[label].length;
      var txt = '· ' + n + (n === 1 ? ' part' : ' parts');
      if (cntEl.textContent !== txt) cntEl.textContent = txt;
      desired.push(h);
      groups[label].forEach(function (c) { desired.push(c); });
    });
    tail.forEach(function (c) { desired.push(c); });
    Object.keys(heads).forEach(function (k) {
      if (labels.indexOf(k) === -1 && !heads[k].hidden) heads[k].hidden = true;
    });
    // Idempotent reorder: only touch the DOM when the sequence actually differs,
    // else the MutationObserver re-hydration path would loop forever.
    var current = Array.prototype.filter.call(grid.children, function (el) {
      return el.hasAttribute('data-fitment-make-heading') ||
        (el.classList && el.classList.contains('grid__item') && el.hasAttribute('data-product-handle'));
    });
    var same = current.length === desired.length && desired.every(function (n2, i) { return current[i] === n2; });
    if (!same) desired.forEach(function (n2) { grid.appendChild(n2); });
  }

  function ticketIcon(kind) {
    // Signature pen: 6.5/48 stroke ratio (3.25 in the 24 box), butt caps,
    // hard joins - kin to the corner arrows and gallery chevrons.
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '20'); svg.setAttribute('height', '20');
    svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '3.25');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d',
      kind === 'check' ? 'M4 12.5 L9.5 18 L20 5' :
      kind === 'x' ? 'M5 5 L19 19 M19 5 L5 19' :
      'M12 4 V20 M4 12 H20');
    svg.appendChild(path);
    return svg;
  }

  function hydratePdp() {
    var band = document.querySelector('[data-fitment-pdp]');
    if (band) {
      // Build with DOM nodes + textContent only; labels come from the index but this keeps the invariant visible.
      var prevBandClass = band.className;
      var g = getGarage();
      var handle = band.getAttribute('data-fitment-handle');
      var pdata = index.products[handle];
      var status = g ? core.fitStatus(index, handle, g.vehicleIdx, g.year) : (pdata ? null : 'unknown');
      // Legacy products carry no application data: fitStatus would call them
      // 'no-fit' for EVERY car, which is a false verdict (e.g. detent springs
      // fit Civics). No data -> no ticket, in any state.
      if (pdata && !pdata.universal && (!pdata.fitments || !pdata.fitments.length)) status = 'unknown';
      var buildTicket = function (state, iconKind, labelTxt, sentenceTxt, bold, action) {
        band.textContent = '';
        band.className = 'fitment-pdp-band fitment-pdp-band--' + state;
        if (iconKind) {
          var iconWrap = document.createElement('span');
          iconWrap.className = 'fitment-pdp-band__icon';
          iconWrap.setAttribute('aria-hidden', 'true');
          iconWrap.appendChild(ticketIcon(iconKind));
          band.appendChild(iconWrap);
        }
        var body = document.createElement('div');
        body.className = 'fitment-pdp-band__body';
        var label = document.createElement('span');
        label.className = 'fitment-pdp-band__label hrd-micro';
        label.textContent = labelTxt;
        body.appendChild(label);
        var sent = document.createElement(bold ? 'strong' : 'span');
        sent.className = 'fitment-pdp-band__sentence';
        sent.textContent = sentenceTxt;
        body.appendChild(sent);
        if (action) body.appendChild(action);
        band.appendChild(body);
        // Quiet escape on verdict tickets (Kevin 2026-08-05): the only path
        // out for owners whose real car is not in the picker (legacy cars) -
        // change-car cannot reach the no-garage state. Clears SITEWIDE.
        if (state !== 'prompt') {
          var clearBtn = document.createElement('button');
          clearBtn.type = 'button';
          clearBtn.className = 'fitment-pdp-band__clear hrd-micro';
          clearBtn.setAttribute('data-fitment-clear', '');
          clearBtn.textContent = 'Clear car';
          band.appendChild(clearBtn);
        }
        band.hidden = false;
      };
      if (status === 'unknown') {
        band.textContent = '';
        band.hidden = true; // product not in the index (published after last build): say nothing false
      } else if (!g) {
        var openBtn = document.createElement('button');
        openBtn.type = 'button';
        openBtn.className = 'fitment-btn-save fitment-btn-save--on-white';
        openBtn.setAttribute('data-fitment-open', '');
        openBtn.textContent = 'Select your car';
        buildTicket('prompt', null, 'Check fitment', 'Confirm this part for your build.', false, openBtn);
      } else if (status === 'fits') {
        buildTicket('fits', 'check', 'Verified fit', 'Fits your ' + g.label + '.', true, null);
      } else if (status === 'universal') {
        var spec = index.products[handle] && index.products[handle].spec;
        buildTicket('universal', 'check', spec || 'Universal fit', 'Works with your ' + g.label + '.', false, null);
      } else {
        var alt = core.familyMatch(index, handle, g.vehicleIdx, g.year);
        var a = document.createElement('a');
        a.className = 'fitment-pdp-band__recover';
        if (alt) { a.href = '/products/' + alt; a.textContent = 'See the version for your car'; }
        else { a.href = SHOP_FITS_URL; a.textContent = 'Shop parts for your car'; }
        buildTicket('no-fit', 'x', 'No fit', 'Does not fit your ' + g.label + '.', true, a);
      }
      if (band.className !== prevBandClass && band.dataset.fitmentSwapReady === '1' && !reducedMotion()) {
        band.classList.remove('fitment-swap-in');
        void band.offsetWidth;
        band.classList.add('fitment-swap-in');
      }
      band.dataset.fitmentSwapReady = '1';
    }
    // Add-on rows: the ticket's authority, per row. Curated lists can cross
    // chassis (shifting/knob combos fit most cars but not all), so each row
    // verifies against ITS OWN application table. fits -> dot + note;
    // no-fit -> disarm + family-match reroute; legacy/unknown -> silent,
    // never a false verdict either way.
    var addonRows = document.querySelectorAll('.addon-item[data-addon-handle]');
    if (addonRows.length) {
      var ag = getGarage();
      var anyVerifiable = false;
      Array.prototype.forEach.call(addonRows, function (row) {
        var rp = index.products[row.getAttribute('data-addon-handle')];
        if (rp && (rp.universal || (rp.fitments && rp.fitments.length))) anyVerifiable = true;
      });
      // One question, once (Kevin 2026-08-05): the band's prompt already asks
      // for the car. This block-level ask prints ONLY when the band is silent
      // (legacy/unindexed host) and a row could still verify.
      var bandEl = document.querySelector('.fitment-pdp-band');
      var bandAsking = !!(bandEl && !bandEl.hidden);
      var verifyPrompt = document.querySelector('[data-addon-verify-prompt]');
      if (verifyPrompt) verifyPrompt.hidden = !(!ag && anyVerifiable && !bandAsking);
      Array.prototype.forEach.call(addonRows, function (row) {
        var h = row.getAttribute('data-addon-handle');
        var cb = row.querySelector('.addon-checkbox');
        var note = row.querySelector('[data-addon-fit]');
        if (!cb || !note) return;
        var ap = index.products[h];
        var verifiable = ap && (ap.universal || (ap.fitments && ap.fitments.length));
        var st = ag && verifiable ? core.fitStatus(index, h, ag.vehicleIdx, ag.year) : null;
        note.className = 'addon-fit';
        row.classList.remove('addon-item--no-fit');
        if (st === 'fits') {
          note.classList.add('addon-fit--fits');
          note.textContent = 'Fits your ' + ag.label;
          note.hidden = false;
          cb.disabled = false;
        } else if (st === 'universal') {
          if (ap.spec) { note.textContent = ap.spec; note.hidden = false; } else { note.textContent = ''; note.hidden = true; }
          cb.disabled = false;
        } else if (st === 'no-fit') {
          note.classList.add('addon-fit--no-fit');
          note.textContent = "Doesn't fit your " + ag.label;
          var alt = core.familyMatch(index, h, ag.vehicleIdx, ag.year);
          if (alt) {
            note.appendChild(document.createTextNode(' · '));
            var altLink = document.createElement('a');
            altLink.href = '/products/' + alt;
            altLink.textContent = 'See the version for your car';
            note.appendChild(altLink);
          }
          note.hidden = false;
          row.classList.add('addon-item--no-fit');
          if (cb.checked) {
            cb.checked = false;
            cb.dispatchEvent(new Event('change', { bubbles: true }));
          }
          cb.disabled = true;
        } else {
          note.textContent = '';
          note.hidden = true;
          cb.disabled = false;
        }
      });
    }
    var list = document.querySelector('[data-fitment-list]');
    if (list) {
      var p = index.products[list.getAttribute('data-fitment-handle')];
      if (p && p.fitments.length) {
        var table = document.createElement('div');
        table.className = 'fitment-table';
        p.fitments.forEach(function (i) {
          var vv = index.vehicles[i];
          var row = document.createElement('div');
          row.className = 'fitment-table__row';
          var years = document.createElement('span');
          years.className = 'fitment-table__years';
          years.textContent = vv.year_start + '-' + (vv.year_end == null ? 'Present' : vv.year_end);
          var veh = document.createElement('span');
          veh.className = 'fitment-table__vehicle';
          veh.textContent = vv.make + ' ' + vv.model;
          row.appendChild(years);
          row.appendChild(veh);
          if (vv.chassis) {
            var ch = document.createElement('span');
            ch.className = 'fitment-table__chassis hrd-micro';
            ch.textContent = vv.chassis;
            row.appendChild(ch);
          }
          table.appendChild(row);
        });
        list.textContent = '';
        list.appendChild(table);
      }
    }
  }

  function bindPills() {
    document.querySelectorAll('[data-fitment-pill]').forEach(function (pill) {
      if (pill.dataset.fitmentBound === '1') return;
      pill.dataset.fitmentBound = '1';
      pill.addEventListener('click', function () {
        var make = pill.getAttribute('data-fitment-pill');
        var g = getGarage();
        var paginated = !!document.querySelector('.pagination');
        if (!g && !paginated) {
          // anchor mode: jump to the make heading; focus announces it
          var target = findHeading(make);
          if (target && !target.hidden) {
            // First paint after the jump: promote the group's first rows to eager
            var seen = 0;
            var node = target.nextElementSibling;
            while (node && seen < 6) {
              if (node.hasAttribute('data-fitment-make-heading')) break;
              if (node.hasAttribute('data-product-handle')) {
                node.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
                seen++;
              }
              node = node.nextElementSibling;
            }
            target.setAttribute('tabindex', '-1');
            target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
            target.focus({ preventScroll: true });
          }
          return;
        }
        activePill = activePill === make ? null : make;
        document.querySelectorAll('[data-fitment-pill]').forEach(function (p) {
          p.setAttribute('aria-pressed', p.getAttribute('data-fitment-pill') === activePill ? 'true' : 'false');
        });
        hydrateGrids();
        announce(activePill ? 'Showing ' + activePill + ' parts.' : 'Showing all parts.');
      });
    });
  }

  // Pinned camo: hold the band's camo viewport-stationary so adjacent camo surfaces read as one field.
  function bindPinnedCamo() {
    var imgs = document.querySelectorAll('.fitment-camo--pinned img');
    if (!imgs.length) return;
    var ticking = false;
    function place() {
      ticking = false;
      imgs.forEach(function (img) {
        var rect = img.parentElement.getBoundingClientRect();
        img.style.transform = 'translateY(' + (-rect.top) + 'px)';
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(place);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    place();
  }

  // Impulse re-renders #CollectionAjaxContent innerHTML on sort/filter; re-hydrate when that happens.
  function observeAjaxContent() {
    var target = document.getElementById('CollectionAjaxContent');
    if (!target || !window.MutationObserver) return;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        bindPills();
        hydrateBars();
        hydrateGrids();
        observer.takeRecords(); // discard mutations caused by the hydration pass itself
      });
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  /* ---------- selector overlay ---------- */
  var overlay = null;
  var lastOpener = null;
  var swapTimer = null;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function garageVehicle(g) { return index.vehicles[g.vehicleIdx]; }

  function guardFocus(e) {
    if (!overlay || overlay.hidden) return;
    var panel = overlay.querySelector('[data-fitment-panel]');
    if (panel && !panel.contains(e.target)) {
      var f = panel.querySelector('[data-fitment-fields]:not([hidden]) .hrd-select-btn:not([disabled]), [data-fitment-fields]:not([hidden]) select:not([disabled]):not([data-hrd-enhanced])') ||
        panel.querySelector('[data-fitment-confirm]:not([hidden]) button:not([hidden]), [data-fitment-confirm]:not([hidden]) a[href]:not([hidden])') ||
        panel.querySelector('.fitment-overlay__close');
      if (f) f.focus();
    }
  }

  function showConfirm(root) {
    var g = getGarage();
    if (!g) return;
    var v = garageVehicle(g);
    var fields = root.querySelector('[data-fitment-fields]');
    var confirm = root.querySelector('[data-fitment-confirm]');
    if (!fields || !confirm) return;
    var doSwap = function () {
      swapTimer = null;
      if (!overlay || overlay.hidden) return;
      fields.classList.remove('fitment-swap-out');
      fields.hidden = true;
      confirm.hidden = false;
      var kicker = root.querySelector('[data-fitment-kicker]');
      var t1 = root.querySelector('[data-fitment-title-1]');
      var t2 = root.querySelector('[data-fitment-title-2]');
      var meta = root.querySelector('[data-fitment-confirm-meta]');
      var warm = root.querySelector('[data-fitment-confirm-warm]');
      if (kicker) kicker.textContent = 'Your garage';
      if (t1) t1.textContent = String(g.year);
      if (t2) t2.textContent = v.model;
      if (meta) meta.textContent = v.chassis ? 'Chassis ' + v.chassis + ' · On file' : 'On file';
      if (warm) warm.textContent = 'Engineering happiness for your ' + v.model + '.';
      var link = root.querySelector('[data-fitment-confirm-link]');
      var closeCta = root.querySelector('[data-fitment-confirm-close-cta]');
      var pdp = document.querySelector('[data-fitment-pdp]');
      var pdpKnown = !!(pdp && index.products[pdp.getAttribute('data-fitment-handle')]);
      if (closeCta && (pdpKnown || document.querySelector('[data-fitment-bar]'))) {
        closeCta.textContent = pdpKnown ? 'Check this part' : 'See your parts';
        closeCta.hidden = false;
        if (link) link.hidden = true;
        closeCta.focus();
      } else if (link) {
        var shopUrl = root.getAttribute('data-fitment-shop-url');
        if (shopUrl) link.href = shopUrl;
        link.hidden = false;
        if (closeCta) closeCta.hidden = true;
        link.focus();
      }
    };
    if (reducedMotion()) { doSwap(); }
    else {
      fields.classList.add('fitment-swap-out');
      swapTimer = setTimeout(doSwap, 150);
    }
  }

  /* Branded YMM dropdowns (deviations 106 + 108): the native popup cannot be
     styled, so on desktop each YMM select (garage overlay AND the home
     console rail) becomes hidden data storage behind a button + listbox in
     the reviews-sort vocabulary. Items rebuild from the live options on
     EVERY open, so fillSelect repopulation needs no observers; the
     placeholder option lives on the button, never in the menu. syncAll
     defers a tick after change so it always reads the state AFTER the
     cascade handlers repopulate downstream selects. The wrapping label is
     the click zone (clicking "01 Year" opens the menu). */
  var ymmDesktop = window.matchMedia('(min-width: 769px)');

  function enhanceOverlaySelects(root) {
    var sels = [
      root.querySelector('[data-fitment-year]'),
      root.querySelector('[data-fitment-make]'),
      root.querySelector('[data-fitment-model]')
    ];
    if (sels.some(function (s) { return !s; })) return;

    function syncAll() {
      parts.forEach(function (p) {
        var opt = p.sel.options[p.sel.selectedIndex];
        p.btn.textContent = opt ? opt.textContent : '';
        p.btn.disabled = p.sel.disabled;
        p.close();
      });
    }

    var parts = sels.map(function (sel) {
      sel.setAttribute('data-hrd-enhanced', '');
      var wrap = document.createElement('span');
      wrap.className = 'hrd-select';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hrd-select-btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      var menu = document.createElement('ul');
      menu.className = 'hrd-select-menu';
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;
      wrap.appendChild(btn);
      wrap.appendChild(menu);
      sel.parentNode.insertBefore(wrap, sel.nextSibling);

      function close() {
        menu.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      }

      function choose(i) {
        if (sel.selectedIndex !== i) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        close();
        btn.focus();
        syncAll();
      }

      function openMenu() {
        while (menu.firstChild) menu.removeChild(menu.firstChild);
        Array.prototype.forEach.call(sel.options, function (opt, i) {
          if (opt.disabled) return;
          var li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.setAttribute('tabindex', '-1');
          li.setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false');
          li.textContent = opt.textContent;
          li.addEventListener('click', function () { choose(i); });
          li.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(i); }
            else if (e.key === 'Escape') { e.preventDefault(); close(); btn.focus(); }
            else if (e.key === 'ArrowDown') { e.preventDefault(); (li.nextElementSibling || menu.firstElementChild).focus(); }
            else if (e.key === 'ArrowUp') { e.preventDefault(); (li.previousElementSibling || menu.lastElementChild).focus(); }
            else if (e.key === 'Tab') { close(); }
          });
          menu.appendChild(li);
        });
        if (!menu.children.length) return;
        menu.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        var cur = menu.querySelector('[aria-selected="true"]') || menu.firstElementChild;
        if (cur) { cur.focus(); if (cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' }); }
      }

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (menu.hidden) { openMenu(); } else { close(); }
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && menu.hidden && !btn.disabled) { e.preventDefault(); openMenu(); }
        else if (e.key === 'Escape' && !menu.hidden) { e.preventDefault(); close(); }
      });
      sel.addEventListener('change', function () { setTimeout(syncAll, 0); });
      // The whole field label is the hit zone: clicking "01 Year" toggles the
      // menu (the label's native forwarding targets the hidden select - inert).
      var zone = sel.closest('label') || wrap;
      if (zone !== wrap) {
        zone.addEventListener('click', function (e) {
          if (wrap.contains(e.target) || btn.disabled) return;
          e.preventDefault();
          if (menu.hidden) { openMenu(); } else { close(); }
        });
      }
      return { sel: sel, btn: btn, menu: menu, close: close, zone: zone };
    });

    document.addEventListener('click', function (e) {
      parts.forEach(function (p) {
        if (!p.menu.hidden && !p.zone.contains(e.target)) p.close();
      });
    });

    root._hrdSyncSelects = syncAll;
    syncAll();
  }

  function fillSelect(sel, options, placeholder) {
    sel.innerHTML = '';
    var o = document.createElement('option');
    o.value = ''; o.textContent = placeholder; o.disabled = true; o.selected = true;
    sel.appendChild(o);
    options.forEach(function (opt) {
      var e = document.createElement('option');
      e.value = String(opt.value); e.textContent = opt.text;
      sel.appendChild(e);
    });
    sel.disabled = options.length === 0;
  }

  function resetSteps(root) {
    var yearSel = root.querySelector('[data-fitment-year]');
    var makeSel = root.querySelector('[data-fitment-make]');
    var modelSel = root.querySelector('[data-fitment-model]');
    var saveBtn = root.querySelector('[data-fitment-save]');
    if (!yearSel) return;
    fillSelect(yearSel, core.years(index).map(function (y) { return { value: y, text: y }; }), 'Year');
    fillSelect(makeSel, [], 'Make');
    fillSelect(modelSel, [], 'Model');
    if (saveBtn) saveBtn.disabled = true;
    var confirm = root.querySelector('[data-fitment-confirm]');
    var fields = root.querySelector('[data-fitment-fields]');
    if (confirm) confirm.hidden = true;
    if (fields) { fields.hidden = false; fields.classList.remove('fitment-swap-out'); }
    var kicker = root.querySelector('[data-fitment-kicker]');
    var t1 = root.querySelector('[data-fitment-title-1]');
    var t2 = root.querySelector('[data-fitment-title-2]');
    if (kicker) kicker.textContent = '"Dual Duty" starts with the right fit';
    if (t1) t1.textContent = 'Select';
    if (t2) t2.textContent = 'your car.';
    var meta = root.querySelector('[data-fitment-confirm-meta]');
    var warm = root.querySelector('[data-fitment-confirm-warm]');
    if (meta) meta.textContent = '';
    if (warm) warm.textContent = '';
  }

  /* Home console only (Kevin ruling 2026-08-07). With a car on file the rail
     sat empty and disarmed while the header chip two rows above read the
     customer's car back to them - it was the one garage-aware surface that
     ignored the garage, and it asked a returning customer to pick their car
     again from scratch. It now opens pre-filled and armed: one tap to their
     parts. Every step is verified against the live index rather than trusted,
     because the garage stores a vehicle index and the table can be rebuilt
     under it; if any step no longer resolves the caller resets to a clean
     picker, which is the honest fallback. Deliberately NOT applied to the
     overlay - deviation 41 ratified that reopening "Change car" resets to a
     fresh picker. */
  function prefillFromGarage(root, yearSel, makeSel, modelSel, saveBtn) {
    var g = getGarage();
    if (!g || g.vehicleIdx == null || !index || !index.vehicles) return false;
    var v = index.vehicles[g.vehicleIdx];
    if (!v) return false;

    yearSel.value = String(g.year);
    if (yearSel.value !== String(g.year)) return false;

    fillSelect(makeSel, core.makesForYear(index, Number(g.year)).map(function (m) {
      return { value: m, text: m };
    }), 'Make');
    makeSel.value = v.make;
    if (makeSel.value !== v.make) return false;

    fillSelect(modelSel, core.modelsForYearMake(index, Number(g.year), v.make).map(function (m) {
      return { value: m.vehicleIdx, text: m.model + (m.chassis ? ' · ' + m.chassis : '') };
    }), 'Model');
    modelSel.value = String(g.vehicleIdx);
    if (modelSel.value !== String(g.vehicleIdx)) return false;

    if (saveBtn) saveBtn.disabled = false;
    return true;
  }

  function bindSelector(root) {
    var yearSel = root.querySelector('[data-fitment-year]');
    var makeSel = root.querySelector('[data-fitment-make]');
    var modelSel = root.querySelector('[data-fitment-model]');
    var saveBtn = root.querySelector('[data-fitment-save]');
    if (!yearSel || !makeSel || !modelSel || !saveBtn) return;

    resetSteps(root);

    if (getGarage() && root.matches && root.matches('[data-fitment-inline]')) {
      if (!prefillFromGarage(root, yearSel, makeSel, modelSel, saveBtn)) resetSteps(root);
    }
    // Overlay + home console rail, desktop only; the late gate also catches
    // a first open that happened below the breakpoint before a resize up.
    if (ymmDesktop.matches && !root._hrdSyncSelects && root.closest &&
        (root.closest('.fitment-overlay') || root.closest('[data-fitment-inline]'))) {
      enhanceOverlaySelects(root);
    }
    if (root.dataset.fitmentBound === '1') {
      if (root._hrdSyncSelects) root._hrdSyncSelects();
      return;
    }
    root.dataset.fitmentBound = '1';

    yearSel.addEventListener('change', function () {
      fillSelect(makeSel, core.makesForYear(index, Number(yearSel.value)).map(function (m) { return { value: m, text: m }; }), 'Make');
      fillSelect(modelSel, [], 'Model');
      saveBtn.disabled = true;
    });
    makeSel.addEventListener('change', function () {
      var models = core.modelsForYearMake(index, Number(yearSel.value), makeSel.value);
      fillSelect(modelSel, models.map(function (m) {
        return { value: m.vehicleIdx, text: m.model + (m.chassis ? ' · ' + m.chassis : '') };
      }), 'Model');
      saveBtn.disabled = true;
    });
    modelSel.addEventListener('change', function () { saveBtn.disabled = modelSel.value === ''; });

    saveBtn.addEventListener('click', function () {
      setGarage(Number(modelSel.value), Number(yearSel.value));
      var redirect = root.getAttribute('data-fitment-redirect');
      if (redirect) { window.location.href = redirect; return; }
      if (root.querySelector('[data-fitment-confirm]')) {
        showConfirm(root);
      } else {
        var heroLine = root.querySelector('[data-fitment-hero-confirm]') ||
          (root.closest && root.closest('.fitment-hero') ? root.closest('.fitment-hero').querySelector('[data-fitment-hero-confirm]') : null);
        if (heroLine) {
          var g2 = getGarage();
          var lbl2 = heroLine.querySelector('[data-fitment-hero-label]');
          if (lbl2 && g2 && lbl2.textContent !== g2.label) lbl2.textContent = g2.label;
          var lnk = heroLine.querySelector('[data-fitment-hero-link]');
          var su = root.getAttribute('data-fitment-shop-url');
          if (lnk && su) lnk.href = su;
          heroLine.hidden = false;
        } else {
          closeSelector();
        }
      }
    });

    var clearBtn = root.querySelector('[data-fitment-clear]');
    if (clearBtn) clearBtn.addEventListener('click', function () { clearGarage(); closeSelector(); });
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !overlay || overlay.hidden) return;
    var focusables = Array.prototype.filter.call(
      overlay.querySelectorAll('button:not([disabled]), select:not([disabled]):not([data-hrd-enhanced]), a[href]'),
      function (el) { return !el.closest('[hidden]'); }
    );
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openSelector(opener) {
    if (!overlay || !index) return;
    document.dispatchEvent(new CustomEvent('modalOpen')); // Impulse drawers close themselves on this
    lastOpener = opener || document.activeElement;
    overlay.hidden = false;
    document.documentElement.classList.add('fitment-overlay-open');
    if (lastOpener && lastOpener.setAttribute) lastOpener.setAttribute('aria-expanded', 'true');
    bindSelector(overlay.querySelector('[data-fitment-panel]'));
    var first = overlay.querySelector('[data-fitment-year]');
    if (first) first.focus();
    document.addEventListener('focusin', guardFocus); // absorbs Impulse's 500ms drawer focus restore
  }
  function closeSelector() {
    if (!overlay || overlay.hidden) return;
    if (swapTimer) { clearTimeout(swapTimer); swapTimer = null; }
    var f = overlay.querySelector('[data-fitment-fields]');
    if (f) f.classList.remove('fitment-swap-out');
    document.removeEventListener('focusin', guardFocus);
    overlay.hidden = true;
    document.documentElement.classList.remove('fitment-overlay-open');
    if (lastOpener && lastOpener.setAttribute) lastOpener.setAttribute('aria-expanded', 'false');
    if (lastOpener && lastOpener.isConnected && lastOpener.focus) {
      lastOpener.focus();
    } else {
      var band = document.querySelector('[data-fitment-pdp]');
      if (band && !band.hidden) { band.setAttribute('tabindex', '-1'); band.focus(); }
    }
    lastOpener = null;
  }

  /* ---------- boot ---------- */
  var ready = fetch(indexUrl)
    .then(function (r) { if (!r.ok) throw new Error('fitment index ' + r.status); return r.json(); })
    .then(function (data) {
      if (!data || !Array.isArray(data.vehicles) || !data.products) throw new Error('fitment index malformed');
      index = data; return index;
    })
    .catch(function () { return null; }); // degrade: unfiltered browsing, chrome stays hidden

  window.HRDFitment = { getGarage: getGarage, setGarage: setGarage, clearGarage: clearGarage, openSelector: openSelector, ready: ready };

  function boot() {
    overlay = document.querySelector('[data-fitment-overlay]');
    ready.then(function (ok) {
      if (!ok) return;
      document.documentElement.classList.add('fitment-ready');
      var live = document.createElement('div');
      live.setAttribute('data-fitment-live', '');
      live.setAttribute('aria-live', 'polite');
      live.className = 'visually-hidden';
      document.body.appendChild(live);

      document.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-fitment-open]') : null;
        if (t) { e.preventDefault(); openSelector(t); return; }
        var c = e.target.closest ? e.target.closest('[data-fitment-close]') : null;
        if (c) { e.preventDefault(); closeSelector(); return; }
        var cg = e.target.closest ? e.target.closest('[data-fitment-clear]') : null;
        if (cg) { e.preventDefault(); clearGarage(); announce('Saved car cleared.'); return; }
        var b = e.target.closest ? e.target.closest('[data-fitment-browse-toggle]') : null;
        if (b) {
          e.preventDefault();
          browseAll = !browseAll;
          hydrateBars();
          hydrateGrids();
          var gb = getGarage();
          if (gb) announce(browseAll ? 'Showing all parts. Your ' + gb.label + ' stays saved.' : 'Showing parts for ' + gb.label + '.');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSelector();
        trapFocus(e);
      });
      document.addEventListener('animationend', function (e) {
        if (e.target && e.target.classList) e.target.classList.remove('fitment-entering', 'fitment-swap-in');
      });
      document.querySelectorAll('[data-fitment-inline]').forEach(bindSelector);
      bindPills();
      bindPinnedCamo();
      observeAjaxContent();
      document.addEventListener('hrd:vehicle:change', function () {
        document.querySelectorAll('[data-fitment-hero-confirm]').forEach(function (el) { el.hidden = true; }); // staleness guard; save re-shows after
        hydrateBars(); hydrateGrids(); hydratePdp();
        // The console follows the garage in BOTH directions: saving a car from
        // the overlay arms it, clearing one empties it back to a fresh picker.
        // Without this it kept whatever it was rendered with until a reload.
        document.querySelectorAll('[data-fitment-inline]').forEach(function (root) {
          var yearSel = root.querySelector('[data-fitment-year]');
          var makeSel = root.querySelector('[data-fitment-make]');
          var modelSel = root.querySelector('[data-fitment-model]');
          var saveBtn = root.querySelector('[data-fitment-save]');
          if (!yearSel || !makeSel || !modelSel) return;
          resetSteps(root);
          if (getGarage() && !prefillFromGarage(root, yearSel, makeSel, modelSel, saveBtn)) resetSteps(root);
          if (root._hrdSyncSelects) root._hrdSyncSelects();
        });
      });
      broadcast();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
